import type { EstimateDays } from './api';

// Keep the manual editors on the estimate v2 server contract. Do not round
// values: a rejected value must remain visible for the user to correct.
export const ESTIMATE_DAYS_MIN = 0.5;
export const ESTIMATE_DAYS_MAX = 60;

function validDay(value: number): boolean {
  return Number.isFinite(value) && value >= ESTIMATE_DAYS_MIN && value <= ESTIMATE_DAYS_MAX
    && Number.isInteger(value * 2);
}

/** Decimal dot/comma, ranges, TBD and not-applicable markers on both surfaces. */
export function parseEstimateDays(raw: string): EstimateDays | null {
  const text = raw.trim();
  if (/^tbd$/i.test(text)) return 'TBD';
  if (/^[–—-]$/.test(text)) return '–';
  const numeric = '(?:\\d+(?:[.,]\\d+)?|[.,]\\d+)';
  const range = text.match(new RegExp(`^(${numeric})\\s*[–—-]\\s*(${numeric})$`));
  if (range) {
    let first = Number(range[1].replace(',', '.'));
    let last = Number(range[2].replace(',', '.'));
    if (!validDay(first) || !validDay(last)) return null;
    if (first > last) [first, last] = [last, first];
    return first === last ? first : [first, last];
  }
  if (!new RegExp(`^${numeric}$`).test(text)) return null;
  const value = Number(text.replace(',', '.'));
  return validDay(value) ? value : null;
}
